<template>
  <p class="flex flex-col col-span-full gap-2 mb-4">
    <span class="font-bold">
      {{ trans.get('miliboo.header.search.no-results') }}
    </span>
    <span class="text-sm">
      {{ trans.get('miliboo.header.search.empty-search') }}
    </span>
  </p>
</template>
<script setup>
import { inject } from 'vue';

const trans = inject('translate');

</script>
